import { styled } from '@notino/react-styleguide';

export const Link = styled.a`
  color: inherit;
`;
